export * from './request-management.service';
export * from './deal-status.service';
export * from './deal.service';
export * from './general.service';
export * from './service-item.service';
export * from './term.service';
export * from './user.service';
export * from './parameter.service';
export * from './term-of-use.service';
export * from './infra.service';


// WEBPACK FOOTER //
// ./src/app/services/_index.ts